import { FormControlLabel, Switch, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";

const SwitchField = ({ name, label, disabled, size = "small", ...rest }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          control={
            <Switch
              size={size}
              checked={!!field.value}
              onChange={(e) => field.onChange(e.target.checked)}
              disabled={disabled}
            />
          }
          label={<Typography variant="caption">{label}</Typography>}
          {...rest}
        />
      )}
    />
  );
};

export default SwitchField;
